import $ from 'jquery';
import ClipboardJS from 'clipboard';
import Splitting from 'splitting';
import flatpickr from "flatpickr";
import dayjs from 'dayjs';
import gsap from 'gsap';

// utils
import common from '../utils/common';
import map from '../utils/map';
import reviews from '../utils/reviews';
import mobile from '../utils/mobile';
import drop from '../utils/drop';
import galerie from '../utils/galerie';
import fitEllipsisLine from '../utils/fitEllipsis';
import { ensureRecaptcha } from '../utils/recaptcha';


//pages
import transfers from '../pages/transfers';
import initSwiper from '../utils/swiper';
import bookingSheet from '../pages/product_booking_sheet';


const product = {
	array_dates: '',
	maxQuantity: 0,
	minQuantity: 0,
	placesLeft: 0,
	totalQuantity: 0,
	dateChoosen: '',
	hourChoosen: '',
	id: '',
	code: '',
	name: '',
	type_price: '',
	type: '',
	roundTripSave: false,
	roundTrip: false,
	roundTripPrice: false,
	activ: false,
	activMenu: false,
	reservable: false,
	moduleContact: false,
	valid: false,
	scanValidity: false,
	header_height: 0,
	gal_nb: 0,
	list_reviews: '',
	basket: false,
	is_mobile: false,
	calendarObj: null,

	init() {
		this.initPackageOptionsSheet();
		this.initClipboard();
		this.initAnchors();
		this.detectReservable();
		this.setupScrollbars();
		this.loadProductData();
		this.initModules();
		this.handleBasket();
		this.initMap();
		this.initItineraryMap();
		this.bindMenuToggle();
		this.initCalendars();
		this.informations();
		this.quickAnswersSearch();
		this.guides();
		this.suggestions();
		this.initAccomodationsSwiper();
		this.fitInterests();
		this.initDrawerPro();
		this.initDrawerContact();
		mobile.init();
		drop.init();
		galerie.lightbox();
		this.initGalleryParallax();
		if (mobile.state === true) {
			this.mobile();
		}
	},

	initDrawerPro() {
		const $drawer = $("[data-drawer-pro]");
		if (!$drawer.length) return;

		const $backdrop = $("[data-drawer-pro-backdrop]");

		const open = () => {
			$drawer.addClass("_open");
			$backdrop.addClass("_show");
			$("html,body").addClass("_overflow");
		};

		const close = () => {
			$drawer.removeClass("_open");
			$backdrop.removeClass("_show");
			$("html,body").removeClass("_overflow");
		};

		$(document).on("click", "._btn_pro", open);
		$(document).on("click", "[data-drawer-pro-close]", close);
		$(document).on("click", "[data-drawer-pro-backdrop]", close);
		$(document).on("keydown", (e) => {
			if (e.key === "Escape" && $drawer.hasClass("_open")) close();
		});
	},

	initDrawerContact() {
		const $drawer = $("[data-drawer-contact]");
		if (!$drawer.length) return;

		const $backdrop = $("[data-drawer-contact-backdrop]");

		const open = () => {
			ensureRecaptcha();
			$drawer.addClass("_open");
			$backdrop.addClass("_show");
			$("html,body").addClass("_overflow");
		};

		const close = () => {
			$drawer.removeClass("_open");
			$backdrop.removeClass("_show");
			$("html,body").removeClass("_overflow");
		};

		this._openDrawerContact = open;

		$(document).on("click", "[data-drawer-contact-close]", close);
		$(document).on("click", "[data-drawer-contact-backdrop]", close);
		$(document).on("keydown", (e) => {
			if (e.key === "Escape" && $drawer.hasClass("_open")) close();
		});
	},

	initPackageOptionsSheet() {
		const $sheet = $('#package_options_sheet');
		if (!$sheet.length) return;

		const $backdrop = $('.__package_options_backdrop');
		const $button = $('.__package_options_open');
		const close = () => {
			$sheet.removeClass('_open _dragging').css('transform', '').attr('aria-hidden', 'true');
			$backdrop.removeClass('_show');
			$button.attr('aria-expanded', 'false');
			$('html,body').removeClass('_overflow');
		};
		$button.on('click', () => {
			mobile.closeMobileMenu();
			mobile.closeBasket();
			$sheet.addClass('_open').attr('aria-hidden', 'false');
			$backdrop.addClass('_show');
			$button.attr('aria-expanded', 'true');
			$('html,body').addClass('_overflow');
		});
		$backdrop.on('click', close);
		$(document).on('keydown', (event) => {
			if (event.key === 'Escape' && $sheet.hasClass('_open')) close();
		});
		let startY = 0;
		$sheet.find('.__package_options_handle').on('touchstart', (event) => {
			startY = event.originalEvent.touches[0].clientY;
		}, {passive: true}).on('touchend', (event) => {
			if (event.originalEvent.changedTouches[0].clientY - startY > 80) close();
		});
		$(window).on('resize', () => {
			if (window.innerWidth >= 993 && $sheet.hasClass('_open')) close();
		});
	},

	quickAnswersSearch() {
		const $search = $(".__product_faq_search_input");

		if (!$search.length) {
			return;
		}

		const normalize = (value) => value
			.toString()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.toLowerCase();
		const $questions = $(".__product_faq .__ul_faq > li");

		$search.on("input", (event) => {
			const query = normalize($(event.currentTarget).val().trim());
			let visibleQuestions = 0;

			$questions.each((index, element) => {
				const $question = $(element);
				const searchableText = normalize($question.find(".__question, .__answer").text());
				const matches = !query || searchableText.includes(query);

				$question.toggle(matches);
				if (matches) {
					visibleQuestions++;
				}
			});

			$(".__product_faq_no_result").toggleClass("_show", visibleQuestions === 0);
			$("#product-faq-results").toggleClass("_no_matches", visibleQuestions === 0);
			$("#product-faq-results").attr("aria-label", `${visibleQuestions} result${visibleQuestions > 1 ? "s" : ""} found`);
		});
	},
	fitInterests() {
		const container = document.querySelector(".__product_interests");
		if (!container) return;

		fitEllipsisLine(container);

		// ResizeObserver plutot qu'un listener "resize" : recalcule aussi quand
		// la largeur du conteneur bouge pour d'autres raisons que le
		// redimensionnement de la fenetre (police web qui finit de charger...).
		new ResizeObserver(() => fitEllipsisLine(container)).observe(container);
	},

	informations() {
		// $(document).on("click", "._close_line", function () {
		// 	$(this).toggleClass("_close");
		// 	$(this).next().toggleClass("_close");
		// });
		// $(document).on("click", "._head_info", function () {
		// 	$(this).parent().find("._close_line").toggleClass("_close");
		// 	$(this).parent().find("._content_line").toggleClass("_close");
		// });

		// "Expand all" / "Collapse all" - ouvre/ferme tous les <details
		// class="_line_info"> d'un coup (ils restent par ailleurs pilotables
		// individuellement, comportement natif <details>/<summary>, pas de JS
		// dedie necessaire pour ca).
		$(document).on("click", ".__informations_toggle_all", function () {
			const $btn = $(this);
			const $details = $(".__informations_list ._line_info");
			const expand = $btn.attr("data-state") !== "expanded";

			$details.prop("open", expand);
			$btn.attr("data-state", expand ? "expanded" : "collapsed");
			$btn.find("span").text(expand ? "Collapse all" : "Expand all");
		});

		// La carte "Meeting point" est initialisee au chargement (initMap())
		// mais vit dans un <details> ferme par defaut ici (contrairement a
		// product_meeting_point.php, toujours visible, utilise sur les pages
		// package qui partagent ce meme module JS) - Leaflet la calcule donc
		// sur un conteneur a taille nulle. On invalide sa taille a chaque
		// ouverture (evenement natif <details>) pour qu'elle se redessine
		// correctement.
		$(document).on("toggle", ".__product_informations details._meeting_point", function () {
			if (this.open && map.view) {
				map.view.invalidateSize();
			}
		});
	},

	// Leger parallax vertical sur les photos de la galerie au scroll (cf.
	// retours utilisateur) : chaque vignette est deplacee en fonction de sa
	// position dans le viewport (haut -> decalee vers le haut, bas -> vers
	// le bas), sans transition CSS pour rester parfaitement synchrone avec
	// le defilement. L'image deborde volontairement de son cadre cote SCSS
	// (._grid_medias._grid_galery ._elt_grid .__img, height:118%/top:-9%)
	// pour ne jamais reveler de vide pendant le decalage. Le zoom au survol
	// reste sur l'<img> lui-meme (transform independant), donc pas de
	// conflit entre les deux animations.
	initGalleryParallax() {
		if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
			return;
		}

		const $imgs = $("._grid_medias._grid_galery ._elt_grid .__img")
			.not("._grid_5 ._elt_grid:nth-of-type(3) .__img");
		if (!$imgs.length) {
			return;
		}

		let ticking = false;

		const update = () => {
			const vh = window.innerHeight;

			$imgs.each(function () {
				const rect = this.getBoundingClientRect();
				const center = rect.top + rect.height / 2;
				const progress = Math.max(-1, Math.min(1, (center - vh / 2) / (vh / 2)));
				const range = Math.min(14, rect.height * 0.08);

				this.style.transform = `translateY(${(progress * range).toFixed(1)}px)`;
			});

			ticking = false;
		};

		$(window).on("scroll.galleryParallax resize.galleryParallax", () => {
			if (!ticking) {
				requestAnimationFrame(update);
				ticking = true;
			}
		});

		update();
	},

	initClipboard() {
		const clipboard = new ClipboardJS('._btn_copy_code');
		clipboard.on('success', () => {
			$("._tip_code").show();
			setTimeout(() => {
				$("._tip_code").hide();
			}, 1000);
		});
	},

	initAnchors() {
		$(document).on("click", "._go_anchor", function (e) {
			e.preventDefault();
			const section = $(this).data("nav");
			const $target = $("._section_product[data-nav=" + section + "]");
			if (!$target.length) return;
			gsap.to(window, {
				scrollTo: {y: $target.offset().top - 200}
			});
		});
	},

	detectReservable() {
		this.reservable = $("input[name=non_reservable]").length > 0;
	},

	setupScrollbars() {
		if (!mobile.state) {
			// $(".contain_drop").mCustomScrollbar({
			// 	theme: "white",
			// 	mouseWheel: {scrollAmount: 250}
			// });
		}
	},

	guides() {

		initSwiper('.__guides', {
			loop: false,
			autoHeight: true,
			spaceBetween: 20,
			navigation: false,
			autoplay: false,
			breakpoints: {
				0: {slidesPerView: '1.2'},
				640: {slidesPerView: '1.8'},
				1024: {slidesPerView: '2.3'},
				1450: {slidesPerView: '3.1'},
			},
		});

	},

	suggestions() {
		if (!document.querySelector('.__suggestions_swiper')) {
			return;
		}

		const suggestionsSwiper = initSwiper('.__suggestions_swiper', {
			loop: false,
			autoHeight: false,
			spaceBetween: 30,
			navigation: true,
			navigationEls: {
				prevEl: '.__suggestions_prev',
				nextEl: '.__suggestions_next',
			},
			autoplay: false,
			breakpoints: {
				0: {slidesPerView: '1.15', spaceBetween: 16},
				640: {slidesPerView: '1.8', spaceBetween: 20},
				1024: {slidesPerView: '2.4', spaceBetween: 28},
				1280: {slidesPerView: 3.5, spaceBetween: 40},
			},
		});

		const prevBtn = document.querySelector('.__suggestions_prev');
		const nextBtn = document.querySelector('.__suggestions_next');

		if (prevBtn && nextBtn && suggestionsSwiper) {
			const updateNavigationState = () => {
				prevBtn.classList.toggle('_disabled', suggestionsSwiper.isBeginning);
				nextBtn.classList.toggle('_disabled', suggestionsSwiper.isEnd);
			};

			suggestionsSwiper.on('slideChange', updateNavigationState);
			suggestionsSwiper.on('resize', updateNavigationState);
			suggestionsSwiper.on('update', updateNavigationState);
			updateNavigationState();
		}
	},

	// Swiper horizontal pour la liste "Accommodation" des pages package,
	// uniquement au palier middle-screen (769px, cf. $middle-screen dans
	// _common_grid.scss) et en dessous - au-dessus, on garde la grille
	// Bootstrap normale (cf. retours utilisateur "grille catastrophe" en
	// empilement vertical sur mobile). Verifie une seule fois au chargement,
	// comme le reste du site (cf. initResponsiveReload() dans common.js, qui
	// recharge deja la page au franchissement du palier desktop/mobile).
	initAccomodationsSwiper() {
		const isCarousel = document.querySelector('.__accomodation_carousel');
		const container = document.querySelector('.__accomodations_swiper');
		if (!container) return;

		if (isCarousel) {
			this.initAccomodationCarousel(container);
			return;
		}

		if (window.innerWidth >= 769) return;

		const accomodationsSwiper = initSwiper('.__accomodations_swiper', {
			loop: false,
			autoHeight: true,
			spaceBetween: 12,
			slidesPerView: 1.08,
			navigation: true,
			navigationEls: {
				prevEl: '.__accomodations_prev',
				nextEl: '.__accomodations_next',
			},
		});

		const prevBtn = document.querySelector('.__accomodations_prev');
		const nextBtn = document.querySelector('.__accomodations_next');
		if (!accomodationsSwiper || !prevBtn || !nextBtn) return;

		const updateNavigationState = () => {
			prevBtn.classList.toggle('_disabled', accomodationsSwiper.isBeginning);
			nextBtn.classList.toggle('_disabled', accomodationsSwiper.isEnd);
		};

		accomodationsSwiper.on('slideChange', updateNavigationState);
		accomodationsSwiper.on('resize', updateNavigationState);
		accomodationsSwiper.on('update', updateNavigationState);
		updateNavigationState();
	},

	initAccomodationCarousel(container) {
		const isMobile = window.innerWidth < 769;
		const totalSlides = container.querySelectorAll('.swiper-slide').length;

		const sw = initSwiper('.__accomodations_swiper', {
			loop: false,
			spaceBetween: 20,
			slidesPerView: isMobile ? 1.15 : 2.5,
			navigation: true,
			navigationEls: {
				prevEl: '.__accomodations_prev',
				nextEl: '.__accomodations_next',
			},
		});

		const prevBtn = document.querySelector('.__accomodations_prev');
		const nextBtn = document.querySelector('.__accomodations_next');

		const updateState = () => {
			if (prevBtn) prevBtn.classList.toggle('_disabled', sw.isBeginning);
			if (nextBtn) nextBtn.classList.toggle('_disabled', sw.isEnd);

		};

		sw.on('slideChange', updateState);
		sw.on('resize', updateState);
		updateState();

		document.querySelectorAll('[data-accomodation-gallery]').forEach(btn => {
			btn.addEventListener('click', (e) => {
				e.stopPropagation();
				const galleryId = 'grid_accomodation_' + btn.dataset.accomodationGallery;
				const galleryEl = document.getElementById(galleryId);
				if (!galleryEl) return;

				const firstImg = galleryEl.querySelector('.__img');
				if (firstImg) firstImg.click();
			});
		});
	},

	loadProductData() {
		this.id = $("input[name=product_id]").val();
		this.code = $("input[name=productCode]").val();
		this.name = $("input[name=productName]").val();
		this.type_price = $("input[name=product_type_price]").val();
		this.type = $("input[name=product_type]").val();
		this.header_height = $(".__ophorus_p_header").height();
		this.activ = true;
	},

	initModules() {
		this.onScroll();
		this.initReviewsLoadMore();
		this.initReviewsViewSwitch();
		this.initReviewsDescToggle();
		//galerie.lightbox();
		this.prepareOptions();
		if (this.type === "TRANSFER") {
			transfers.product();
		}
	},

	onScroll() {
		const navItems = document.querySelectorAll(".__product_nav li");
		const sections = document.querySelectorAll("._section_product");

		// Ajoute un listener pour les clics sur les liens du menu
		navItems.forEach(item => {
			item.addEventListener("click", function () {
				const sectionId = this.dataset.nav;
				const targetSection = document.querySelector(`._section_product[data-nav="${sectionId}"]`);
				if (targetSection) {
					gsap.to(window, {
						scrollTo: targetSection.offsetTop - 200,
						duration: 0.6
					});
				}
			});
		});

		// Crée un observer pour détecter quelle section entre en vue
		// const observerOptions = {
		// 	root: null,
		// 	rootMargin: "0px",
		// 	threshold: 0.5 // Au moins 50% visible
		// };
		//
		// const observer = new IntersectionObserver((entries) => {
		// 	entries.forEach(entry => {
		// 		const sectionNav = entry.target.dataset.nav;
		// 		if (entry.isIntersecting && sectionNav !== product.activMenu) {
		// 			product.activMenu = sectionNav;
		//
		// 			const navContainer = document.querySelector(".__product_nav");
		// 			navContainer.classList.toggle("_up", entry.boundingClientRect.top < 0);
		// 			navContainer.classList.toggle("_down", entry.boundingClientRect.top >= 0);
		//
		// 			navItems.forEach(li => li.classList.remove("_activ"));
		// 			const activeNavItem = document.querySelector(`.__product_nav li[data-nav="${sectionNav}"]`);
		// 			if (activeNavItem) {
		// 				activeNavItem.classList.add("_activ");
		// 			}
		//
		// 			product.movNav(entry.boundingClientRect.top >= 0 ? "next" : "prev", sectionNav);
		// 		}
		// 	});
		// }, observerOptions);
		//
		// sections.forEach(section => observer.observe(section));
	},

	initReviewsLoadMore() {
		const $section = $("._section_product.__product_reviews");

		if (!$section.length) {
			return;
		}

		const $allItems = $section.find("[data-review-item='true']");
		const $button = $section.find("[data-load-more-reviews='true']");
		const $filters = $section.find("[data-review-filter]");
		const $search = $section.find("[data-reviews-search='true']");
		const $noResult = $section.find(".__reviews_no_result");

		if (!$allItems.length) {
			return;
		}

		const initial = parseInt($section.data("initial"), 10) || 5;
		const step = parseInt($section.data("step"), 10) || 20;

		let visibleCount = initial;
		let searchQuery = "";
		// Ensemble des sources cochees (desktop: liste de cases a cocher,
		// mobile: dropdown "select multiple") - vide = "ALL", cf. retours
		// utilisateur qui veut pouvoir cumuler plusieurs sources a la fois
		// (avant : simple exclusif type radio malgre l'apparence checkbox).
		const activeFilters = new Set();

		const normalize = (value) => value
			.toString()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.toLowerCase();

		const getFilteredItems = () => {
			let items = $allItems;

			if (activeFilters.size) {
				items = items.filter(function () {
					return activeFilters.has($(this).data("review-source"));
				});
			}

			if (searchQuery) {
				items = items.filter(function () {
					return normalize($(this).text()).includes(searchQuery);
				});
			}

			return items;
		};

		const syncFiltersUI = () => {
			$filters.each(function () {
				const $el = $(this);
				const tag = $el.data("review-filter");
				const isActive = tag === "ALL" ? !activeFilters.size : activeFilters.has(String(tag));

				$el.toggleClass("_active", isActive);
				if ($el.is(":checkbox")) {
					$el.prop("checked", isActive);
				}
			});
		};

		const applyFilter = (tag) => {
			visibleCount = initial;

			if (tag === "ALL") {
				activeFilters.clear();
			} else if (activeFilters.has(tag)) {
				activeFilters.delete(tag);
			} else {
				activeFilters.add(tag);
			}

			syncFiltersUI();
			renderReviews();
		};

		const renderReviews = () => {
			const $filteredItems = getFilteredItems();

			$allItems.hide();

			$filteredItems.each(function (index) {
				if (index < visibleCount) {
					$(this).show();
				}
			});

			$noResult.toggleClass("_show", $filteredItems.length === 0);

			if ($button.length) {
				if ($filteredItems.length <= visibleCount) {
					$button.hide();
				} else {
					const remaining = $filteredItems.length - visibleCount;
					const nextBatch = remaining > step ? step : remaining;
					$button.html(`<span>Load ${nextBatch} more reviews</span>`);
					$button.show();
				}
			}
		};

		syncFiltersUI();
		renderReviews();

		$(document)
			.off("click.loadMoreReviews")
			.on("click.loadMoreReviews", "[data-load-more-reviews='true']", function () {
				visibleCount += step;
				renderReviews();
			});

		$search
			.off("input.reviewsSearch")
			.on("input.reviewsSearch", function () {
				searchQuery = normalize($(this).val().trim());
				visibleCount = initial;
				renderReviews();
			});

		// Desktop : cases de la sidebar (._menu_filter, click sur toute la
		// ligne). Mobile : cases a cocher du dropdown "select multiple"
		// (change sur l'input). Les deux partagent le meme attribut
		// data-review-filter et le meme etat activeFilters.
		$(document)
			.off("click.reviewFilter")
			.on("click.reviewFilter", ".__review_filter[data-review-filter]", function () {
				applyFilter(String($(this).data("review-filter")));
			});

		$(document)
			.off("change.reviewFilterMobile")
			.on("change.reviewFilterMobile", ".__reviews_filter_dropdown input[type=checkbox][data-review-filter]", function () {
				applyFilter(String($(this).data("review-filter")));
			});
	},

	initReviewsViewSwitch() {
		const $section = $("._section_product.__product_reviews");

		if (!$section.length) {
			return;
		}

		const $list = $section.find(".__all_reviews");
		const $buttons = $section.find(".__reviews_view_switch [data-review-view]");

		if (!$list.length || !$buttons.length) {
			return;
		}

		$(document)
			.off("click.reviewsViewSwitch")
			.on("click.reviewsViewSwitch", "._section_product.__product_reviews .__reviews_view_switch [data-review-view]", function () {
				const view = $(this).data("review-view");

				$buttons.removeClass("_active");
				$(this).addClass("_active");
				$list.attr("data-review-view", view);
			});
	},

	initReviewsDescToggle() {
		const $section = $("._section_product.__product_reviews");

		if (!$section.length) {
			return;
		}

		$(document)
			.off("click.reviewsDescToggle")
			.on("click.reviewsDescToggle", "._section_product.__product_reviews [data-desc-toggle='true']", function () {
				const $btn = $(this);
				const $desc = $btn.siblings("[data-review-desc='true']");
				const $short = $desc.find(".__desc_short");
				const $full = $desc.find(".__desc_full");
				const expanded = !$full.hasClass("_hide");

				$short.toggleClass("_hide", !expanded);
				$full.toggleClass("_hide", expanded);
				$btn.find("span").text(expanded ? "Read more" : "Read less");
			});
	},

	prepareOptions() {
		const hasOffers = $(".__btns_offres").length > 0;
		const hasExtras = $(".__btns_extras").length > 0;

		if (hasOffers && !hasExtras) {
			$(".__btns_offres").show();
			$(".__options_offres").show();
		}
	},
	handleBasket() {
		if ($("input[name=already_basket]").length > 0) {
			this.basket = true;
			this.openBooking();
			$(".--price_ind").hide();
		}
		if ($("input[name=basket_participants]").length > 0) {
			this.totalQuantity = $("input[name=basket_participants]").val();
		}
	},

	initMap() {
		if ($("input[name=lat]").length > 0) {
			const lat = $("input[name=lat]").val();
			const lng = $("input[name=lng]").val();
			if (lat && lng) {
				map.init(lat, lng);
			}
		}
	},

	initItineraryMap() {
		const $toggle = $("[data-itinerary-map-toggle]");
		const $container = $("[data-itinerary-map]");

		if (!$toggle.length || !$container.length) {
			return;
		}

		$toggle.on("click", () => {
			const isHidden = $container.hasClass("_hide");

			$container.toggleClass("_hide", !isHidden);
			$toggle.find("[data-label-show]").toggleClass("_hide", isHidden);
			$toggle.find("[data-label-hide]").toggleClass("_hide", !isHidden);

			if (isHidden) {
				const points = JSON.parse($container.attr("data-route") || "[]");
				map.initRoute("__itinerary_map_canvas", points, $container);
				setTimeout(() => map.refreshRoute(), 50);
			}
		});
	},

	bindMenuToggle() {
		$(document).on("click", ".--show_contain", function () {
			const forceOpen = $(this).hasClass("__force_open");
			if (forceOpen) {
				$(".--contain_options").slideUp(200);
				$(".__booking").removeClass("__force_open");
			} else {
				$(".--contain_options").slideDown(200);
				$(".__booking").addClass("__force_open");
			}
			$(this).toggleClass("__force_open");
			$(".__booking").toggleClass("__bottom_open");
		});
	},

	initCalendars() {
		if (!this.reservable) {
			$(document).on("click", ".__header_booking", function () {
				if (!mobile.state) {
					$(this).hide();
					product.openBooking();
				}
			});

			// Liste custom des horaires (miroir du <select name=_horaires> cache,
			// pour un menu deroulant identique en style a Participants/Date)
			$(document).on("click", ".__ul_hours > li:not(._sold_out)", function () {
				const $li = $(this);
				const value = $li.data("value");

				$li.siblings().removeClass("_activ");
				$li.addClass("_activ");

				const time = $li.find(".__hour_time").text() || $li.text();
				const avail = $li.find(".__hour_avail").text();
				const $blInput = $(".--product_hours .bl_input");
				$("#_horaires_display").val(time);
				$blInput.find(".__hour_avail").remove();
				$blInput.removeClass("_sold_out");
				if (avail) {
					$blInput.append(`<span class="__hour_avail">${avail}</span>`);
				}

				$("select[name=_horaires]").val(value).trigger("change");

				$("._menu_dropdown[data-drop='hours']").removeClass("_show");
				$(".bl_input[data-drop='hours']").removeClass("_opened");
			});

			// CALENDRIER PRINCIPAL - absent sur les pages package (booking
			// deleguee aux fiches produit individuelles, cf.
			// PAGES/PACKAGE/package_booking.php qui n'a pas ce champ), pas de
			// calendrier a charger dans ce cas.
			const _code = $("input[name=productCode]").val();
			if (_code) {
				this.calendar("principal", _code, this.id, $("._calendar"));
			}

			// CALENDRIER RETOUR POUR TRANSFER
			if (this.type === "TRANSFER" && $("input[name=product_roundtrip]").length > 0) {
				const _product_id_return = $("input[name=product_roundtrip]").val();
				const _product_code = $("input[name=product_roundtrip_code]").val();
				this.calendar("transfer", _product_code, _product_id_return, $("._calendar_return"));
			}

			// PASSAGE COMMANDE
			$(document).on("click", ".__btn_book[data-valid=true]", (evt) => {
				if (this.totalQuantity > 0) {
					this.saveBooking();
				}
			});

			// AJOUT EXTRAS
			$(document).on("change", ".__extra_opt", () => {
				this.checkExtras();
			});

			$(document).on("click", ".--save_extras", (evt) => {
				if (!$(evt.currentTarget).hasClass("_desactivate")) {
					this.saveExtras();
				}
			});

			$(document).on("click", ".--no_extras", (evt) => {
				this.nextStep("extra");
				this.saveExtras(true);
			});

			$(document).on("click", ".--return_extras", (evt) => {
				this.nextStep("home");
			});

			$(document).on("click", ".--no_offres", (evt) => {
				this.nextStep("offres");
			});

		} else {
			this.bookingContact();
			this.moduleContact = true;

			$(document).on("click", ".__header_booking", () => {
				if (product._openDrawerContact) product._openDrawerContact();
			});
		}
	},

	nextStep(from) {
		if (from === "extra") {
			if ($(".__btns_offres").length > 0) {
				$(".__btns_extras").hide();
				$(".__btns_offres").show();
				$(".__options_extras").hide();
				$(".__options_offres").show();
			} else {
				location.href = _SITE_URL + "ophorus-cmd";
			}
		} else if (from === "home") {
			$(".__btns_extras").show();
			$(".__options_extras").show();
			$(".__options_offres").hide();
			$(".__btns_offres").hide();
		} else {
			location.href = _SITE_URL + "ophorus-cmd";
		}
	},

	// Modules à compléter :
	openBooking() {
		$(".__booking").removeClass("__closed");

		if (!$(".--show_contain").hasClass("__force_open")) {
			$(".--contain_options").slideDown(200);
			$(".--show_contain").addClass("__force_open");
		}

		$(".__price_total_mobile").css('display', 'flex');
		$(".__price_mobile").hide();
		$(".__btn_open_booking > ._open > span").html("View Booking options");
	},
	bookingContact() {
		$(".__load_product").hide();
		$(".__btn_open_booking").addClass("_available");
		$(".__header_booking").show();
		$(".__price").css("opacity", "1");

		const startDate = new Date().fp_incr(+2); // +2 jours

		$("._calendar_contact").flatpickr({
			altInput: true,
			nextArrow: '<svg><use xlink:href=\"#__ic_arrow_fleche\"/></svg>',
			prevArrow: '<svg class=\"_inverse\"><use xlink:href=\"#__ic_arrow_fleche\"/></svg>',
			altFormat: "M j, Y",
			mode: "range",
			dateFormat: "Y-m-d",
			minDate: startDate,
			defaultDate: [startDate, startDate],
			position: "auto center",
			onChange(selectedDates, dateStr) {
				if (selectedDates.length === 2) {
					$("input[name=date_deb]").val(dayjs(selectedDates[0]).format("YYYY-MM-DD"));
					$("input[name=date_end]").val(dayjs(selectedDates[1]).format("YYYY-MM-DD"));
				} else if (selectedDates.length === 1) {
					$("._calendar_search").val(dateStr);
					$("input[name=date_deb]").val(dateStr);
					$("input[name=date_end]").val("");
				} else {
					$("input[name=date_deb]").val("");
					$("input[name=date_end]").val("");
				}
			}
		});
	},
	checkExtras() {
		let validButton = false;

		$("input[type=checkbox].__extra_opt").each(function () {
			if ($(this).prop("checked")) {
				validButton = true;
			}
		});

		$("input[type=number].__extra_opt").each(function () {
			if ($(this).val() > 0) {
				validButton = true;
			}
		});

		if (validButton) {
			$(".--save_extras").removeClass("_desactivate");
		} else {
			$(".--save_extras").addClass("_desactivate");
		}
	},
	saveExtras(clean = false) {
		const arrayExtras = [];

		$("input[name*=extra]").each(function () {
			const $el = $(this);
			if ($el.data("id") !== undefined) {
				const extra = {
					extra_id: $el.data("id"),
					label: $el.data("label"),
					type: $el.data("type"),
					price: $el.data("price"),
					value: $el.is(':checkbox') ? $el.prop('checked') : $el.val()
				};
				arrayExtras.push(extra);
			}
		});

		$.ajax({
			url: `${_SITE_URL}book-extras`,
			type: 'post',
			data: {
				extras: arrayExtras,
				product_id: this.id,
				clean
			},
			success: (response) => {
				const obj = $.parseJSON(response);
				$("._recap_booking > .__contain").html(obj);
				this.nextStep("extra");
			}
		});
	},
	saveBooking() {
		const self = this;

		const arrayOpt = [];
		$("input[data-op]").not(".__extra_opt").each(function () {
			arrayOpt.push({
				type: $(this).data("type") || '',
				label: $(this).data("label") || '',
				id: $(this).data("id") || '',
				num: $(this).val() || 0
			});
		});

		const priceForce = $("input[name=force_price]").val() || 0;
		const horaireEl = $("select[name=_horaires]").find("option:selected");
		const horaire = horaireEl.length ? horaireEl.val() : '';
		const optionIdFromHoraire = horaireEl.length ? horaireEl.data("id") : '';

		const arrTransfer = [];
		if (self.type === "TRANSFER") {
			const transferType = $("input[name=transfer_choice]:checked").val() || '';
			const transferDate01 = $("input[name=product_date]").val() || '';
			const transferTime01 = $("input[name=_transfer_time_01]").val() || '';
			const productRound = self.roundTripSave;

			let transferDate02 = '';
			let transferTime02 = '';
			if (transferType === "RT") {
				transferTime02 = $("input[name=_transfer_time_02]").val() || '';
				transferDate02 = $("input[name=_transfer_date_round]").val() || '';
			}

			arrTransfer.push({
				type: transferType,
				product_round: productRound,
				date_first: transferDate01,
				time_first: transferTime01,
				date_round: transferDate02,
				time_round: transferTime02
			});
		}

		$.ajax({
			url: `${_SITE_URL}book-product`,
			type: 'post',
			data: {
				option: arrayOpt,
				product_id: self.id,
				product_type: self.type,
				date: self.dateChoosen,
				horaire,
				option_id_from_horaire: optionIdFromHoraire,
				price: priceForce,
				transfer: arrTransfer
			},
			success(response) {
				let obj;
				try {
					obj = $.parseJSON(response);
				} catch (e) {
					console.error("Erreur parsing JSON:", e, response);
					return;
				}

				if (obj) {
					if ($("input[name=show_extras]").length > 0 || $("input[name=show_offres]").length > 0) {
						$(".--modal-booking").addClass("_show");
						$("html,body").css("overflow", "hidden");
						$("._recap_booking > .__contain").html(obj);
						self.checkExtras();
					} else {
						window.location.href = `${_SITE_URL}ophorus-cmd`;
					}
				} else {
					console.warn("Réponse vide ou invalide reçue.");
				}
			},
			error(xhr, status, error) {
				console.error("Erreur AJAX:", status, error, xhr.responseText);
			}
		});
	},

	calendar(mode, code, productId, calendarElement) {
		const self = this;

		self.maxQuantity = $("input[name=max_required]").val() || 0;
		self.minQuantity = $("input[name=min_required]").val() || 0;

		//console.log(calendarElement);

		$.ajax({
			url: `${_SITE_URL}get-avaibilities`,
			type: 'post',
			data: {
				product: code,
				product_id: productId
			},
			success(response) {
				let valid;
				try {
					valid = JSON.parse(response);
				} catch (e) {
					console.error("Erreur parsing JSON:", e, response);
					return;
				}

				if (mode === "principal") {
					self.scanValidity = true;
				}

				if (valid && Object.keys(valid).length > 0) {
					self.valid = true;
					self.array_dates = valid;

					const dates = Object.keys(valid);
					let firstDate = dates[0];

					if (calendarElement.hasClass("_calendar")) {
						firstDate = $("input[name=date_basket]").val() || firstDate;
					}
					if (calendarElement.hasClass("_calendar_return")) {
						firstDate = $("input[name=date_dountrip_basket]").val() || firstDate;
					}

					self.calendarObj = flatpickr(calendarElement[0], {
						altInput: true,
						defaultDate: firstDate,
						altFormat: "F j, Y",
						dateFormat: "Y-m-d",
						minDate: dates[0],
						locale: {firstDayOfWeek: 1},
						enable: dates,
						// Sur mobile, le calendrier vit en permanence dans son propre
						// ecran du bottom sheet (cf. product_booking_sheet.js) : pas de
						// popup a positionner/detacher, "inline" le rend directement a
						// l'endroit ou #__calendar_01 a ete deplace.
						inline: mobile.state,
						// Cale le popup (largeur fixe, cf. _ophorus_product_booking.scss)
						// sur le bord DROIT du champ "Date" plutot que le bord gauche
						// par defaut de flatpickr - cf. retours utilisateur.
						position: "below right",
						nextArrow: '<svg><use xlink:href=\"#__ic_arrow_fleche\"/></svg>',
						prevArrow: '<svg class=\"_inverse\"><use xlink:href=\"#__ic_arrow_fleche\"/></svg>',
						onReady(selectedDates, dateStr, instance) {
							instance.calendarContainer.classList.add("_calendar_price");
							self.updateCells(instance);

							if (!mobile.state) {
								// Flatpickr n'a pas de bouton de fermeture natif : on ajoute
								// le meme "Close" que les menus Participants/Heure du bloc
								// reservation (cf. .__close_drop, sass/SITE/pages/product/
								// _ophorus_product_booking.scss). Inutile en mode inline
								// mobile (pas de popup a fermer, l'ecran du sheet s'en
								// charge via son propre bouton Continue).
								const $closeDrop = $('<div class="__close_drop"><span>Close</span></div>');
								$closeDrop.on("click", () => instance.close());
								$(instance.calendarContainer).append($closeDrop);
							}
						},
						onOpen(selectedDates, dateStr, instance) {
							self.updateCustomDateCells(instance);
						},
						onMonthChange(selectedDates, dateStr, instance) {
							self.updateCells(instance);
						},
						onYearChange(selectedDates, dateStr, instance) {
							self.updateCells(instance);
						},
						onChange(selectedDates, dateStr, instance) {
							self.updateCells(instance);
							if (self.array_dates[dateStr]?.length > 0) {
								self.showDate(self.array_dates[dateStr], dateStr, instance.input);
							}
						}
					});

					if ($("#__calendar_01").val()) {
						self.showDate(self.array_dates[$("#__calendar_01").val()], $("#__calendar_01").val());
					} else if (self.array_dates[dates[0]]?.length > 0) {
						self.showDate(self.array_dates[dates[0]], dates[0]);
					}

					$(".--no_dates").hide();
					$(".__load_product").hide();
					$(".__btn_open_booking").addClass("_available");
					if (!self.basket) {
						$(".__header_booking").show();
					}
					$(".__price").addClass("_show");

				} else {
					$(".__btn_open_booking").hide();
					$(".__mobile_no_dates").addClass("_open");
					$(".--no_dates").show();
					$(".__load_product").hide();
					$(".__header_booking").hide();
					$(".__main_booking").hide();
				}
			},
			error(xhr, status, error) {
				console.error("Erreur AJAX calendrier:", status, error, xhr.responseText);
			}
		});
	},
	updateCells(instance) {
		const self = this;
		$(".flatpickr-day").find(".custom-price").remove();

		const dateCells = instance.calendarContainer.querySelectorAll(".flatpickr-day");

		dateCells.forEach((cell) => {
			const ariaLabel = cell.getAttribute("aria-label");
			const formattedDate = dayjs(ariaLabel).format('YYYY-MM-DD');

			cell.setAttribute("data-date", formattedDate);

			const dateData = self.array_dates[formattedDate];
			if (dateData !== undefined && dateData.length > 0) {
				const price = dateData[0].price;
				const color = dateData[0].color;

				if (color) {
					cell.classList.add(color);
				}

				if (price !== undefined) {
					const priceFloat = parseFloat(price.replace(/,/g, ""));
					const priceFormatted = Number.isInteger(priceFloat) ? priceFloat.toFixed(0) : priceFloat;

					const customContent = document.createElement("span");
					customContent.classList.add("custom-price");
					customContent.textContent = `${priceFormatted}€`;

					cell.appendChild(customContent);
				}
			}
		});
	},
	updateCustomDateCells(instance) {
		const self = this;
		$(".flatpickr-day").find(".custom-price").remove();

		const dateCells = instance.calendarContainer.querySelectorAll(".flatpickr-day");

		dateCells.forEach((cell) => {
			const dateStr = cell.getAttribute("data-date");
			const dateData = self.array_dates[dateStr];

			if (dateData !== undefined && dateData.length > 0) {
				const price = dateData[0].price;
				const color = dateData[0].color;

				if (color) {
					cell.classList.add(color);
				}

				if (price !== undefined) {
					const priceFloat = parseFloat(price);
					const priceFormatted = Math.round(priceFloat);

					const customContent = document.createElement("span");
					customContent.classList.add("custom-price");
					customContent.textContent = `${priceFormatted}€`;

					cell.appendChild(customContent);
				}
			}
		});
	},
	showDate(results, date, input = '') {
		const self = this;

		if (input && $(input).hasClass("_calendar_return")) {
			self.checkBtnBooking();
		}

		self.dateChoosen = date;

		if (results.length > 0) {
			self.gestionPlacesLeft(results[0].places);
		}

		const $select = $(".--product_hours").find("select");
		const $list = $("#_horaires_list");
		const $hoursBlock = $(".--product_hours");
		const $blInput = $hoursBlock.find(".bl_input");
		$select.off("change").empty();
		$list.empty();
		$blInput.find(".__hour_avail").remove();
		$blInput.removeClass("_sold_out");

		if (results.length > 1) {
			$hoursBlock.show();

			let firstAvailableSelected = false;
			results.forEach((el) => {
				const isFull = el.places === 0;
				const availText = isFull ? 'Sold out' : `${el.places} available`;

				$select.append($('<option>', {
					value: el.start,
					'data-price': el.price,
					'data-id': el.id,
					text: `${el.start_us} - ${availText}`,
					disabled: isFull
				}));

				const $li = $('<li>', {
					'data-value': el.start,
					'data-price': el.price,
					'data-id': el.id
				});
				$li.append(`<span class="__hour_time">${el.start_us}</span><span class="__hour_avail${isFull ? ' _sold_out' : ''}">${availText}</span>`);
				if (isFull) {
					$li.addClass('_sold_out');
				}
				if (!firstAvailableSelected && !isFull) {
					firstAvailableSelected = true;
					$li.addClass('_activ');
					self.ModPriceHoraire(el.price);
					$("#_horaires_display").val(el.start_us);
					$blInput.append(`<span class="__hour_avail">${availText}</span>`);
					self.hourChoosen = el.start;
				}
				$list.append($li);
			});
		} else {
			$hoursBlock.hide();

			if (results.length === 1) {
				const isFull = results[0].places === 0;
				const availText = isFull ? 'Sold out' : `${results[0].places} available`;
				if (!isFull) {
					self.hourChoosen = results[0].start;
					self.ModPriceHoraire(results[0].price);
				}
				$hoursBlock.show();
				$("#_horaires_display").val(results[0].start_us);
				$blInput.append(`<span class="__hour_avail${isFull ? ' _sold_out' : ''}">${availText}</span>`);
				if (isFull) {
					$blInput.addClass("_sold_out");
				}
			}
		}

		if ($("input[name=_horaire_basket]").length > 0) {
			const horaireBasket = $("input[name=_horaire_basket]").val();
			$select.find(`option[value='${horaireBasket}']`).prop("selected", true);

			const $matchLi = $list.find(`li[data-value='${horaireBasket}']`);
			if ($matchLi.length > 0) {
				$list.find("li").removeClass("_activ");
				$matchLi.addClass("_activ");
				$("#_horaires_display").val($matchLi.text());
			}
		}

		$select.on("change", function () {
			self.hourChoosen = $(this).find("option:selected").val();
			self.getPriceFromDate(date);
			self.getPlacesFromHours(self.hourChoosen);
		});

		self.getPriceFromDate(date);

		$(".__load_product").hide();
		$(".--contain_options").show();
	},
	getPriceFromDate(date) {
		const self = this;
		const arrayOpt = [];

		$("input[data-op]").not(".__extra_opt").each(function () {
			arrayOpt.push({
				type: $(this).data("type") || '',
				label: $(this).data("label") || '',
				id: $(this).data("id") || '',
				num: $(this).val() || 0
			});
		});

		if ($("select[name=_horaires]").length > 0) {
			self.hourChoosen = $("select[name=_horaires]").find("option:selected").val()
				|| $("select[name=_horaires]").find("option:first-child").val();
		}

		$.ajax({
			url: `${_SITE_URL}get-price-from-date`,
			type: 'post',
			data: {
				option: arrayOpt,
				date,
				hour: self.hourChoosen,
				product: self.id
			},
			success(response) {
				let obj;
				try {
					obj = $.parseJSON(response);
				} catch (e) {
					console.error("Erreur parsing JSON:", e, response);
					return;
				}

				if (Array.isArray(obj) && obj.length > 0) {
					const minPriceObj = obj.reduce((min, current) =>
							parseFloat(current.price) < parseFloat(min.price) ? current : min,
						obj[0]
					);

					$(".__price_ind_show").html(minPriceObj.price);

					obj.forEach((val) => {
						const label = val.label;
						const $search = $(`.__bl_line[data-bl-label='${label}']`);
						if ($search.length > 0) {
							$search.find("small").html(`€ ${val.price} /person`);
						}
					});

					$(".__price,.__price_mobile").css("opacity", "1");
					self.getPrice();
				} else {
					console.warn("Pas de prix trouvés pour cette date.");
				}
			},
			error(xhr, status, error) {
				console.error("Erreur AJAX get-price-from-date:", status, error, xhr.responseText);
			}
		});
	},
	ModPriceHoraire(price) {
		const self = this;

		$(`.__bl_line[data-bl='CUSTOM'] > ._quantity_label`).find("small").html(`€ ${price} /person`);

		if (self.totalQuantity > 0) {
			self.getPrice();
		}
	},
	gestionPlacesLeft(places) {
		const self = this;

		self.placesLeft = places;
		$("input[name=places_availables]").val(places);

		const disablePlus = (parseInt(self.maxQuantity) === parseInt(self.totalQuantity))
			|| (parseInt(self.placesLeft) === parseInt(self.totalQuantity));

		if (disablePlus) {
			$("button._plus._book").addClass("_disabled").attr("disabled", "disabled");
		} else {
			$("button._plus._book").removeClass("_disabled").removeAttr("disabled");
		}

		if (self.placesLeft < self.maxQuantity) {
			$(".nb_advert")
				.html(`<span>Only <small>${self.placesLeft} places</small> left on this tour</span>`)
				.show();

			if (self.totalQuantity > self.placesLeft) {
				self.totalQuantity = 0;
				$("input[data-op]").not(".__extra_opt").val(0);
				$("._menu_dropdown").addClass("_show");
			}
		} else {
			$(".nb_advert").html("").hide();
		}
	},
	// Libelle du champ recapitulatif "Participants" (bl_input replie) : au
	// lieu du generique "Participants x N", detaille le nombre par type
	// (Adult/Child/...) a partir du data-label de chaque stepper - cf.
	// retours utilisateur ("1 Adult, 1 Children" plutot que "Participants x 2").
	buildParticipantsLabel() {
		const counts = new Map();

		$("input[data-op]").not(".__extra_opt").each(function () {
			const value = parseInt($(this).val(), 10) || 0;
			if (value <= 0) return;

			const label = $(this).data("label") || "Participant";
			counts.set(label, (counts.get(label) || 0) + value);
		});

		if (counts.size === 0) {
			return "Participants x 0";
		}

		return [...counts.entries()]
			.map(([label, count]) => `${count} ${this.pluralizeParticipantLabel(label, count)}`)
			.join(", ");
	},
	pluralizeParticipantLabel(label, count) {
		if (count <= 1) {
			return label;
		}

		// "Child" est le seul pluriel irregulier courant parmi les labels
		// participants (les autres, configurables cote admin - Adult,
		// Senior, Student... - se pluralisent tous en ajoutant un "s").
		if (/^child$/i.test(label)) {
			return label[0] === label[0].toUpperCase() ? "Children" : "children";
		}

		return /s$/i.test(label) ? label : `${label}s`;
	},
	reinit() {
		const self = this;

		if ($("input[name=product_type]").val() !== "TRANSFER") {
			$("input[name=nb_participants]").val(this.buildParticipantsLabel());
			$(".__total > span").html("€ 0.00");
			$(".__btn_book").attr("data-valid", "false");
			$(".--price_ind").show();
			$(".--price_total").hide();

			$("button._plus._book").removeClass("_disabled").removeAttr("disabled");

			if (self.totalQuantity === 0) {
				$("button._minus._book").addClass("_disabled").attr("disabled", "disabled");
			} else {
				$("button._minus._book").removeClass("_disabled").removeAttr("disabled");
			}

			if ($("input[name=_horaire_basket]").length > 0) {
				self.getPlacesFromHours($("input[name=_horaire_basket]").val());
			}
		}
	},
	getPlacesFromHours(hour) {
		const self = this;

		const arr = $.grep(self.array_dates[self.dateChoosen], function (n) {
			return n.start === hour;
		});

		if (arr && arr.length > 0) {
			self.gestionPlacesLeft(arr[0].places);
		}
	},
	getPlacesFromDate(code, date) {
		$.ajax({
			url: `${_SITE_URL}get-places`,
			type: 'post',
			data: {
				date,
				product: code
			},
			success: (response) => {
				const obj = $.parseJSON(response);
				// Ici, tu peux ajouter le traitement des données reçues si nécessaire
				// Par exemple : this.gestionPlacesLeft(obj.places);
			}
		});
	},
	getPrice() {
		const self = this;
		const arrayOpt = [];

		$("input[data-op]").not(".__extra_opt").each(function () {
			arrayOpt.push({
				type: $(this).data("type") || '',
				label: $(this).data("label") || '',
				id: $(this).data("id") || '',
				num: $(this).val() || 0
			});
		});

		const priceForce = $("input[name=force_price]").val() || 0;

		// La selection des participants est locale : ne pas attendre le prix
		// (ou une date disponible) pour autoriser le retour au recapitulatif.
		self.totalQuantity = arrayOpt.reduce((total, option) => total + (parseInt(option.num, 10) || 0), 0);
		$("input[name=nb_participants]").val(self.buildParticipantsLabel());
		if (bookingSheet.isOpen) {
			bookingSheet.updateContinueState();
		}

		$.ajax({
			url: `${_SITE_URL}get-price`,
			type: 'post',
			data: {
				option: arrayOpt,
				date: self.dateChoosen,
				hour: self.hourChoosen,
				product_id: self.id,
				product_roundTrip: self.roundTrip,
				price: priceForce,
				product_type: self.type
			},
			success(response) {
				let obj;
				try {
					obj = $.parseJSON(response);
				} catch (e) {
					console.error("Erreur parsing JSON:", e, response);
					return;
				}

				if (obj.price_each) {
					$(`.__bl_line[data-bl='EACH'] > ._quantity_label small`).html(`€ ${obj.price_each} /person`);
				}
				if (obj.price_total) {
					$(`.__bl_line[data-bl='TOTAL'] > ._quantity_label small`).html(`€ ${obj.price_total}`);
				}

				if (parseInt(self.maxQuantity) === parseInt(obj.total_places) || parseInt(self.placesLeft) === parseInt(obj.total_places)) {
					$("button._plus._book").addClass("_disabled").attr("disabled", "disabled");
				} else {
					$("button._plus._book").removeClass("_disabled").removeAttr("disabled");
				}

				if (obj.transfers_extras) {
					const total = `<span>€ ${obj.transfers_extras.total_price}</span><small class=\"_single\">Total price - Taxes inc.</small>`;
					$(".--price_total").html(total).show();
					$(".__price_mobile").hide();
					$(".__price_total_mobile > ._contain").html(total);

					if (obj.transfers_extras.nb > 0) {
						$(".--transfer-extras").show().html(obj.transfers_extras.extras);
					} else {
						$(".--transfer-extras").hide();
					}
				} else {
					if (obj.total_places > 0) {
						$(".__btn_book").attr("data-valid", "true");
						const total = `<span>€ ${obj.total_price}</span><small class=\"_single\">Total price - Taxes inc.</small>`;
						$(".--price_total").html(total).show();
						$(".__price_total_mobile > ._contain").html(total);
						$(".__price_total_mobile").css('display', 'flex');
						$(".__price_mobile").hide();
						$(".--price_ind").hide();
						// Selecteur "> h2" ne correspondait a rien (le bouton
						// declencheur desktop utilise un <span>, pas un <h2>) : le
						// texte "Check availability" ne se mettait donc jamais a
						// jour et, surtout, le bouton restait affiche a cote du
						// vrai "Book now" une fois le detail deja ouvert et
						// valide - cf. retours utilisateur.
						$(".__show_book > span").html("Book now");
						$(".__header_booking").hide();
					} else {
						$(".__btn_book").attr("data-valid", "false");
						$(".__price_mobile").show();
						$(".__price_total_mobile").hide();
						$(".--price_ind").show();
						$(".--price_total").hide();
						$(".__show_book > span, .__header_booking > h2").html("Check Availability");
					}
				}

				$("input[name=nb_participants]").val(self.buildParticipantsLabel());
				self.totalQuantity = obj.total_places;

				if (mobile.state) {
					bookingSheet.updateCtaBar();
					if (bookingSheet.isOpen) {
						bookingSheet.renderHub();
						bookingSheet.renderConfirm();
						bookingSheet.updateContinueState();
					}
				}
			},
			error(xhr, status, error) {
				console.error("Erreur AJAX get-price:", status, error, xhr.responseText);
			}
		});
	},
	checkBtnBooking() {
		const self = this;

		if (!self.roundTrip) {
			$(".__btn_book").attr("data-valid", "true");
		} else {
			const dateReturn = $("input._calendar_return").val() || '';
			if (dateReturn === '') {
				$(".__btn_book").attr("data-valid", "false");
			} else {
				$(".__btn_book").attr("data-valid", "true");
			}
		}
	},
	mobile(package_p = false) {
		const self = this;
		self.is_mobile = true;


		if (!self.reservable) {
			bookingSheet.init(self);

			if ($("input[name=force_price_mobile]").length > 0) {
				$(".__price_total_mobile").css('display', 'flex');
				$(".__price_mobile").hide();
			} else {
				const priceVal = $(".--price_ind").html();
				$(".__price_mobile > ._contain").html(priceVal);
				$(".__price_mobile").css("opacity", "1");
			}
		} else {
			$(".__price_mobile").hide();

			$(document).on("click", ".__btn_open_booking", () => {
				if (product._openDrawerContact) product._openDrawerContact();
			});
		}

		const owlIcons = $(".__ul_icons");
		owlIcons.owlCarousel({
			margin: 10,
			stagePadding: 0,
			mouseDrag: true,
			touchDrag: true,
			dots: false,
			items: 3,
			nav: true,
			navText: [
				'<div><svg class=\"_reverse\"><use xlink:href=\"#__ic_arrow_nav\"/></svg></div>',
				'<div><svg class=\"_inverse\"><use xlink:href=\"#__ic_arrow_nav\"/></svg></div>'
			],
			onInitialized(e) {
				const width = $(e.target).find(".owl-stage").width();
				$(e.target).find(".owl-stage").css("width", width + 40);
			},
			responsive: {
				0: {autoWidth: true, margin: 10},
				700: {autoWidth: true, margin: 5, nav: true},
				900: {autoWidth: true, margin: 5}
			}
		});

		const owlNav = $("._ul_nav");
		if (package_p) {
			owlNav.owlCarousel({
				items: 3,
				stagePadding: 20,
				mouseDrag: false,
				touchDrag: true,
				dots: false,
				nav: false,
				responsive: {
					0: {items: 2},
					700: {items: 3},
					900: {items: 4}
				}
			});
		} else {
			owlNav.owlCarousel({
				items: 3,
				margin: 5,
				stagePadding: 20,
				mouseDrag: false,
				touchDrag: true,
				dots: false,
				nav: false,
				onInitialized(e) {
					const width = $(e.target).find(".owl-stage").width();
					$(e.target).find(".owl-stage").css("width", width + 100);
				},
				responsive: {
					0: {autoWidth: true, stagePadding: 10},
					700: {items: 1},
					900: {items: 2}
				}
			});
		}

		let nb = 0;
		$("._ul_nav").find(".owl-item").each(function () {
			nb++;
			$(this).attr("data-nb", nb);
		});

		if (common.$windowW < 768) {
			$('.__owl_produits').owlCarousel({
				items: 2,
				margin: 10,
				stagePadding: 30,
				mouseDrag: false,
				touchDrag: true,
				dots: false,
				nav: false,
				responsive: {
					0: {items: 1},
					600: {items: 2}
				}
			});
		}
	},
	movNav(type, section) {
		const self = this;

		if (self.is_mobile) {
			const owlNav = $("._ul_nav");
			const activeIndex = $("._ul_nav").find("._activ").parent().data("nb");

			if (activeIndex !== undefined) {
				owlNav.trigger('to.owl.carousel', activeIndex - 1);
			}
		}
	}
};

export default product;
